export default __webpack_public_path__ + "static/media/dragonfruit.0282f1e3.png";